/* Cart and checkout click tracking (2026-09-26). All events go to G-R5GK4CN152 only. */
(function () {
  if (window.HermeticaAnalytics20260926) return;
  window.HermeticaAnalytics20260926 = true;

  var GA4_ID = 'G-R5GK4CN152';

  function emit(name, params) {
    if (typeof window.gtag !== 'function') return;
    try {
      var payload = Object.assign({}, params || {}, { send_to: GA4_ID, transport_type: 'beacon' });
      window.gtag('event', 'hsf_' + name, payload);
    } catch (_) {}
  }

  function placement(el) {
    if (el && el.closest && el.closest('cart-drawer-component, .cart-drawer')) return 'drawer';
    if (el && el.closest && el.closest('[class*="sticky"]')) return 'sticky';
    if (/^\/cart\/?$/.test(window.location.pathname)) return 'cart_page';
    return 'other';
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      var submitter = event.submitter;
      if (form.id === 'cart-form' && submitter && submitter.name === 'checkout') {
        emit('checkout_click', { placement: placement(submitter), method: 'checkout_button' });
        return;
      }

      if (form.hasAttribute('data-hsf-cart-upsell')) {
        var idInput = form.querySelector('input[name="id"]');
        emit('cart_upsell_add', {
          placement: placement(form),
          variant_id: idInput ? idInput.value : ''
        });
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;

      var wallet = target.closest('shopify-accelerated-checkout-cart');
      if (wallet) {
        emit('checkout_click', { placement: placement(wallet), method: 'accelerated' });
        return;
      }

      var upgrade = target.closest('[data-hsf-sub-upgrade]');
      if (upgrade && !upgrade.disabled) {
        emit('sub_upgrade_click', {
          placement: placement(upgrade),
          selling_plan: upgrade.getAttribute('data-plan') || ''
        });
      }
    },
    true
  );

  /* Some wallet buttons render inside iframes, where clicks never reach the document.
     Focus moving into an iframe inside the wallet element marks the click. */
  window.addEventListener('blur', function () {
    setTimeout(function () {
      var active = document.activeElement;
      if (!active || active.tagName !== 'IFRAME') return;
      var wallet = active.closest('shopify-accelerated-checkout-cart');
      if (wallet) emit('checkout_click', { placement: placement(wallet), method: 'accelerated' });
    }, 0);
  });

  /* dialog:open does not bubble, so listen in the capture phase. */
  document.addEventListener(
    'dialog:open',
    function (event) {
      var target = event.target;
      if (target instanceof Element && target.matches('cart-drawer-component')) {
        emit('cart_drawer_view', { placement: 'drawer' });
      }
    },
    true
  );
})();
